/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.pushTokenRegistration.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class ExternalProductImage(
    @SerialName("altText")
    val altText: String?,

    @SerialName("original")
    val original: ExternalProductImageSize?,

    @SerialName("large")
    val large: ExternalProductImageSize?,

    @SerialName("medium")
    val medium: ExternalProductImageSize?,

    @SerialName("small")
    val small: ExternalProductImageSize?,

    @SerialName("thumbnail")
    val thumbnail: ExternalProductImageSize?
)
